module.exports = __webpack_public_path__ + "img/workshop1.d264e2a3.jpg";